export default __webpack_public_path__ + "72bc1f002aa1afb63b20628a47226261.png";